import React, { Component } from 'react';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { StandardPage } from "../../Common/pages/StandardPage";
import { RightColumn } from "../../Common/pages/RightColumn";
import HorseRacingFastResults from "./HorseRacingFastResults";
import HorseRacingMostFollowed from "./HorseRacingMostFollowed";

@catchLifeCycleErrors
export default class HorseRacingFastResultsPage extends Component {
  render() {
    const { location } = this.props;

    return (
      <StandardPage sport="racing" title="Fast Results">
        <div className="main-layout-left-column">
          <HorseRacingFastResults location={location}/>
          <div id="left-most-read" className="main-layout-block last-handheld main-layout-hide-desktop">
            <HorseRacingMostFollowed location={location} plainTitle />
          </div>
        </div>

        <RightColumn location={location}
                     sport="racing"
                     content={
                       ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget", "horseRacingMostFollowed"]} />
      </StandardPage>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingFastResultsPage.js